import React, { useMemo } from 'react';
import Currency from 'react-currency-formatter';
import { useTranslation } from 'react-i18next';

// material-ui
import { TableCell, TableRow } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useLanguageReference } from 'services/Hooks/useLanguageReference';
import { useAllInventoryItems } from 'services/Data/InventoryItemServices';
import { arrayUnique } from 'services/Utilities/Utilities';
import { ProjectInventoryItemAdjustmentTypeEnumValue } from 'enums/ProjectInventoryItemAdjustmentTypeEnum';

// Icons

// Styles

// Actions

// Components

// Others

const useStyles = makeStyles(theme => ({
  //...customGlobalStyle(theme),
  projectWallCell: {
    maxWidth: '180px',
    textTransform: 'uppercase',
    borderRight: '1px solid rgba(224, 224, 224, 1)',
    fontSize: 'medium',
  },
  packagePrice: {
    borderLeft: '1px solid rgba(224, 224, 224, 1)',
    fontSize: 'medium',
    textAlign: 'center',
  },
  tableRow: {
    '& td': {
      padding: '10px',
    },
  },
}));

const DealerCopyAdjustmentGroupedProjectWallSection = ({
  categoryLabel,
  projectInventoryItems,
  projectWalls,
  headerColSpan,
  projectAdjustments = [],
  currencyName,
}) => {
  const { t } = useTranslation();
  const classes = useStyles();

  const { descriptionReference } = useLanguageReference();

  const { data: availableInventoryItems } = useAllInventoryItems();

  const totalForSection = projectAdjustments.reduce((acc, cur) => {
    const projectInventoryItem = projectInventoryItems.find(pi => pi.inventoryItem_Id === cur.inventoryItem_Id);

    return acc + cur.quantity * (projectInventoryItem?.projectDealerUnitPrice || 0);
  }, 0);

  const uniqueInventoryItemSkus = useMemo(() => arrayUnique(projectAdjustments.map(pa => pa.inventoryItem_Id)), [
    projectAdjustments,
  ]);

  if (projectInventoryItems?.length === 0) return null;

  return (
    <>
      <TableRow>
        <TableCell colSpan={headerColSpan} style={{ backgroundColor: '#c9c7c7' }}>
          <strong>{categoryLabel}</strong>
        </TableCell>
      </TableRow>

      {uniqueInventoryItemSkus?.map((inventoryItemId, index) => {
        const projectInventoryItem = projectInventoryItems.find(pi => pi.inventoryItem_Id === inventoryItemId);

        const associatedProjectAjustements = projectAdjustments.filter(pa => pa.inventoryItem_Id === inventoryItemId);

        const firstProjectAjustement = associatedProjectAjustements[0];

        const totalQuantity = associatedProjectAjustements.reduce((acc, cur) => acc + (cur.quantity || 0), 0);

        return (
          <TableRow
            className={classes.tableRow}
            key={projectInventoryItem.id}
            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
            {index === 0 && (
              <TableCell colSpan={2} className={classes.projectWallCell} rowSpan={projectAdjustments.length}>
                {`${t('section')} ${t('additional_item')}`}
              </TableCell>
            )}
            <TableCell>
              <strong>{`${
                availableInventoryItems?.find(as => as.id === projectInventoryItem.inventoryItem_Id)?.sku
              }`}</strong>
            </TableCell>
            <TableCell colSpan={2}>{projectInventoryItem?.[descriptionReference]}</TableCell>
            <TableCell align="center">
              {(firstProjectAjustement.adjustmentType === ProjectInventoryItemAdjustmentTypeEnumValue.DealerInventory
                ? Math.abs(totalQuantity)
                : totalQuantity) || '0'}
            </TableCell>
            <TableCell align="right">
              {projectInventoryItem.projectDealerUnitPrice === 0 ? (
                '-'
              ) : (
                <Currency quantity={projectInventoryItem.projectDealerUnitPrice} currency={currencyName} />
              )}
            </TableCell>
            <TableCell align="right">
              <Currency quantity={totalQuantity * projectInventoryItem.projectDealerUnitPrice} currency={currencyName} />
            </TableCell>
            {index === 0 && (
              <TableCell className={classes.packagePrice} rowSpan={projectAdjustments.length}>
                <Currency quantity={totalForSection} currency={currencyName} />
              </TableCell>
            )}
          </TableRow>
        );
      })}
    </>
  );
};

export default DealerCopyAdjustmentGroupedProjectWallSection;
